import Vue from "vue";
import Vuex from "vuex";
import { gocatalogProductsCoverage } from "@/api/gocase-api/products-api/products.api.js";
import {
  catalogSession,
  catalogLogin,
  catalogLogout,
} from "@/api/catalog-api/user-api/user.api.js";
import Api from "@/api/api.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    id: null,
    email: null,
    name: null,
    authority: null,
    token: null,
    coveragePrisma: null,
    isSpecific: null,
    specificMaterial: null,
    specificGroup: null,
  },
  mutations: {
    setId(state, payload) {
      state.id = payload;
    },
    setEmail(state, payload) {
      state.email = payload;
    },
    setName(state, payload) {
      state.name = payload;
    },
    setAuthority(state, payload) {
      state.authority = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setCoveragePrisma(state, payload) {
      state.coveragePrisma = payload;
    },
    setIsSpecific(state, payload) {
      state.isSpecific = payload;
    },
    setSpecificMaterial(state, payload) {
      state.specificMaterial = payload;
    },
    setSpecificGroup(state, payload) {
      state.specificGroup = payload;
    },
  },
  actions: {
    setCache({ commit }, { id, email, name, token, authority }) {
      Api.setCatalogToken({ token });

      commit("setId", id);
      commit("setEmail", email);
      commit("setName", name);
      commit("setToken", token);
      commit("setAuthority", authority);
      if (!token) localStorage.removeItem("user_logged_token");
      else localStorage.setItem("user_logged_token", token);
    },
    checkSession({ dispatch }, { callback }) {
      const token = localStorage.getItem("user_logged_token");
      if (!token) dispatch("logout", { callback });
      else
        catalogSession({ token })
          .then((response) => {
            if (!response) return;
            dispatch("setCache", response);
            if (callback && typeof callback === "function") callback();
          })
          .catch(() => dispatch("logout", { callback }));
    },
    login({ dispatch }, { email, password, otp_attempt, callback }) {
      catalogLogin({ email, password, otp_attempt })
        .then((response) => {
          if (!response) return;
          dispatch("setCache", response);
          if (callback && typeof callback === "function") callback();
        })
        .catch(() => dispatch("logout", { callback }));
    },
    logout({ state, dispatch }, { callback }) {
      const { id, email, token } = state;
      catalogLogout({ id, email, token }).finally(() => {
        dispatch("setCache", {
          id: null,
          email: null,
          name: null,
          token: null,
          authority: null,
        });
        if (callback && typeof callback === "function") callback();
      });
    },
    syncCoveragePrisma({ commit }) {
      gocatalogProductsCoverage().then((r) => commit("setCoveragePrisma", r));
    },
    defineSpecific({ commit }, { material, group }) {
      commit("setSpecificMaterial", material);
      commit("setSpecificGroup", group);
      commit("setIsSpecific", !!material || !!group);
    },
  },
  getters: {
    logged: (state) => {
      return !!state.token;
    },
    authority: (state) => state.authority,
    isAdmin: (state) => {
      if (!state.email) return false;
      return state.authority === "admin";
    },
    isAdvancedUser: (state) => {
      if (!state.email) return false;
      return state.authority === "advanced" || state.authority === "admin";
    },
    isRegisterUser: (state) => {
      if (!state.email) return false;
      return (
        state.authority === "register" ||
        state.authority === "advanced" ||
        state.authority === "admin"
      );
    },
    isIllustrator: (state) => {
      if (!state.email) return false;
      return (
        state.authority === "illustrator" ||
        state.authority === "advanced" ||
        state.authority === "admin"
      );
    },
    isBasicUser: (state) => {
      if (!state.email) return false;
      return (
        state.authority === "illustrator" ||
        state.authority === "basic" ||
        state.authority === "advanced" ||
        state.authority === "admin"
      );
    },
  },
  modules: {},
});

export default store;
